import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import DataTable from "react-data-table-component";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";

export const Students = () => {

    const { apipath, logout, goBack, filepath } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    const [isLoading, setIsLoading] = useState(false);
    const [organizations, setOrganizations] = useState([]);
    const [exams, setExams] = useState([]);
    const [tests, setTests] = useState([]);
    const [studentData, setstudentData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState('');

    const [isOpen, setIsOpen] = useState(false);
    const [isExport, setIsExport] = useState(false);
    const [isStatus, setIsStatus] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedExam, setSelectedExam] = useState('');
    const [selectedTest, setSelectedTest] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [file, setFile] = useState(null);
    const toggleExport = () => {
        setSelectedExam("");
        setSelectedTest("");
        setSelectedUser("");
        setIsExport(!isExport);
    }
    const togglePopup = () => {
        setSelectedExam("");
        setSelectedTest("");
        setSelectedUser("");
        setIsOpen(!isOpen);
    }
    const toggleStatus = () => {
        setSelectedExam("");
        setSelectedTest("");
        setSelectedUser("");
        setSelectedStatus("");
        setIsStatus(!isStatus);
    }

    useEffect(() => {
        const getOrganizations = async () => {
            try {
                const response = await axios.post(
                    apipath + '/organizations',
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        'message': response.data.message,
                        'position': 'topCenter'
                    });
                    logout();
                }
                else if (response.data.status === "false") {
                    iziToast.error({
                        'message': response.data.message,
                        'position': 'topCenter'
                    });
                    return false;
                }
                setOrganizations(response.data.organizations);
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }

            } finally {

            }
        }
        getOrganizations();
    }, []);

    const getExams = async () => {
        try {
            console.log(selectedUser);
            const response = await axios.post(
                apipath + '/exams',
                { 'id': selectedUser },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            setExams(response.data.exams);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {

        }
    }
    useEffect(() => {
        setSelectedExam("");
        setSelectedTest("");
        getExams();
    }, [selectedUser]);


    const getTests = async () => {
        try {
            if (selectedExam) {
                const response = await axios.post(
                    apipath + '/test_schedules',
                    { 'exam_id': selectedExam },
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    return false;
                }
                setTests(response.data.tests);
            }
            else {
                setTests([]);
            }
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {

        }
    }
    useEffect(() => {
        setSelectedTest("");
        getTests();
    }, [selectedExam]);

    const handleFilterChange = (e) => {
        const { value } = e.target;
        setFilters(value);
    }

    const applyFilters = () => {
        console.log(filters);
        let filteredItems = [...studentData];
        const filterValue = filters.toLowerCase();
        if (filterValue) {
            filteredItems = filteredItems.filter(item => {
                return Object.values(item).some(val =>
                    typeof val === 'string' && val.toLowerCase().includes(filterValue)
                );
            });
        }
        setFilteredData(filteredItems);
    }
    useEffect(() => {
        applyFilters();
    }, [filters]);


    const getStudents = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/students',
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter'
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter'
                });
                return false;
            }
            setstudentData(response.data.students);
            setFilteredData(response.data.students);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        getStudents();
    }, []);

    const deleteUser = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/delete_student', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter'
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            getStudents();

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const confirmDeletion = (uid) => {
        iziToast.show({
            color: 'red',
            message: 'Confirm Deletion',
            position: 'topCenter', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter
            buttons: [
                [
                    '<button>Ok</button>',
                    function (instance, toast) {
                        deleteUser(uid);
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ],
                [
                    '<button>Close</button>',
                    function (instance, toast) {
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ]
            ]
        });
    }

    const userStatus = async (uid) => {
        const id = uid;
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/student_status', { 'id': id },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "unauthentic") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter'
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
                getStudents();
            }

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            // setIsLoading(false);
        }
    }
    const editUser = (uid) => {
        localStorage.setItem('editUser', uid);
        navigate('/edit_student');

    }


    const exportStudents = async (e) => {
        e.preventDefault();
        // console.log("export clicked");
        if (!selectedUser || !selectedExam || !selectedTest) {
            iziToast.error({
                message: "All Fields are Required",
                position: "topCenter",

            });
            return false;
        }
        const formData = {
            'organization_id': selectedUser,
            'exam_id': selectedExam,
            'test_id': selectedTest
        }
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/export_students', formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    responseType: 'blob',
                }
            );
            console.log(response.data);
            // Create a new Blob object for the file
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);

            // Create a temporary anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'students.xlsx'); // Specify the file name
            document.body.appendChild(link);
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);

        }
        catch (error) {
            console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        // Process form data
        if (!selectedUser || !selectedExam || !selectedTest) {
            iziToast.error({
                message: "All Fields are Required",
                position: "topCenter",

            });
            return false;
        }
        if (!file || file === null || file === "") {
            iziToast.error({
                message: "Please select file",
                position: "topCenter",

            });
            return false;
        }
        // console.log('Selected User:', selectedUser);
        // console.log('File:', file);

        const formData = new FormData();
        formData.append('organization_id', selectedUser);
        formData.append('exam_id', selectedExam);
        formData.append('test_id', selectedTest);
        formData.append('file', file);
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/import_students', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter'
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            setIsOpen(false);
            setSelectedExam("");
            setSelectedTest("");
            setSelectedUser("");
            getStudents();
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }
        }
        finally {
            setIsLoading(false);
        }
    };


    const activateStudents = async (e) => {
        e.preventDefault();
        // console.log("export clicked");
        if (!selectedUser || !selectedExam || !selectedTest) {
            iziToast.error({
                message: "All Fields are Required",
                position: "topCenter",

            });
            return false;
        }
        const formData = {
            'organization_id': selectedUser,
            'exam_id': selectedExam,
            'test_id': selectedTest,
            'status': selectedStatus
        }
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/activate_students', formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );

            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
            }
            setIsStatus(false);
            setSelectedExam("");
            setSelectedTest("");
            setSelectedUser("");
            getStudents();

        }
        catch (error) {
            console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const [activeTab, setActiveTab] = useState("Student");

    const [searchText, setSearchText] = useState("");

    // Sample data for the table
    // const data = [
    //     { name: "John Doe", email: "john@example.com", phone: "0987654321", city: "hisar", state: "haryana", pincode: "125052" },
    //     { name: "Jane Smith", email: "jane@example.com", phone: "0987654321", city: "hisar", state: "haryana", pincode: "125052" },
    //     { name: "Alice Johnson", email: "alice@example.com", phone: "0987654321", city: "hisar", state: "haryana", pincode: "125052" },
    //     { name: "Bob Brown", email: "bob@example.com", phone: "0987654321", city: "hisar", state: "haryana", pincode: "125052" },
    // ];

    // Define columns for the table
    const columns = [
        { name: "Name", selector: (row) => <><span title={`${row.name}`}>{row.name}</span></>, sortable: true, },
        { name: "Roll No", selector: (row) => <><span title={`${row.roll_no}`}>{row.roll_no}</span></>, sortable: true, },
        { name: "Organization", selector: (row) => <><span title={`${row.organization?.name}`}>{row.organization?.name}</span></>, sortable: true, },
        { name: "Exam", selector: (row) => <><span title={`${row.exam?.exam_name}`}>{row.exam?.exam_name}</span></>, sortable: true, },
        { name: "Test", selector: (row) => <><span title={`${row.test?.test?.test_name} (${row.test?.start_time})`}>{row.test?.test?.test_name + " (" + row.test?.start_time + ")"}</span></>, sortable: true, },
        // { name: "Shift", selector: (row) => <><span title={`${row.test?.start_time}`}>{row.test?.start_time}</span></>, sortable: true, },
        { name: "Email", selector: (row) => <><span title={`${row.email}`}>{row.email}</span></>, sortable: true, },
        { name: "Phone", selector: (row) => <><span title={`${row.phone}`}>{row.phone}</span></>, sortable: true, },
        { name: "City", selector: (row) => <><span title={`${row.city}`}>{row.city}</span></>, sortable: true, },
        { name: "State", selector: (row) => <><span title={`${row.state}`}>{row.state}</span></>, sortable: true, },
        {
            name: "Status", selector: (row) => <>
                <input type="checkbox" onClick={() => userStatus(row.id)} checked={(row.status === 'true')} title={(row.status === "true") ? 'Active' : 'In-Active'} />
            </>, sortable: true,
        },
        {
            name: "Action", selector: (row) => <>
                <i class="fa fa-edit rounded p-1 cursor-pointer text-blue-600 hover:text-white hover:bg-blue-600 border-2 border-blue-600" onClick={() => editUser(row.id)}></i>
                <i class="fa fa-trash rounded p-1 ml-1 cursor-pointer text-red-600 hover:text-white hover:bg-red-600 border-2 border-red-600" onClick={() => confirmDeletion(row.id)}></i>
            </>, sortable: true, width: '100px'
        },
    ];

    // Filter data based on search input
    // const filteredData = studentData.filter((item) =>
    //     item.name.toLowerCase().includes(searchText.toLowerCase()) ||
    //     item.email.toLowerCase().includes(searchText.toLowerCase())
    // );

    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
            </span>
            {<Navbar />}
            {isOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-40">
                    <div className="bg-white p-6 rounded-md shadow-md w-full max-w-md">
                        <h2 className="text-lg font-semibold mb-4">Import Students</h2>
                        <Link to={`${filepath}/public/student_import_sample.xlsx`} download={`student_import_sample.xlsx`} target="_blank" className="text-sm text-blue-500 hover:text-blue-700"><i className="fa fa-download"></i>Sample File</Link>
                        <form onSubmit={handleSubmit}>
                            {/* Select User */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Organization</label>
                                <select
                                    value={selectedUser}
                                    onChange={(e) => setSelectedUser(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Organization</option>
                                    {organizations.map((org) => {
                                        return (<>
                                            <option value={org.id}>{org.name}</option>
                                        </>)
                                    })}
                                </select>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Exam</label>
                                <select
                                    value={selectedExam}
                                    onChange={(e) => setSelectedExam(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Exam</option>
                                    {exams.map((exm) => {
                                        return (<>
                                            <option value={exm.id}>{exm.exam_name}</option>
                                        </>)
                                    })}
                                </select>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Test</label>
                                <select
                                    value={selectedTest}
                                    onChange={(e) => setSelectedTest(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Test</option>
                                    {tests.map((tst) => {
                                        return (<>
                                            <option value={tst.id}>{tst.test?.test_name + " (" + tst.start_time + ")"}</option>
                                        </>)
                                    })}
                                </select>
                            </div>

                            {/* Select File */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select File</label>
                                <input
                                    type="file"
                                    onChange={(e) => setFile(e.target.files[0])}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                />
                            </div>

                            <div className="flex justify-end space-x-2">
                                <button
                                    type="button"
                                    onClick={togglePopup}
                                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {isExport && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-40">
                    <div className="bg-white p-6 rounded-md shadow-md w-full max-w-md">
                        <h2 className="text-lg font-semibold mb-4">Export Students</h2>
                        <form onSubmit={exportStudents}>
                            {/* Select User */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Organization</label>
                                <select
                                    value={selectedUser}
                                    onChange={(e) => setSelectedUser(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Organization</option>
                                    {(userType === 'super_admin') ? <>
                                        <option value={"all"}>All Organization</option>
                                    </> : ""}
                                    {organizations.map((org) => {
                                        return (<>
                                            <option value={org.id}>{org.name}</option>
                                        </>)
                                    })}
                                </select>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Exam</label>
                                <select
                                    value={selectedExam}
                                    onChange={(e) => setSelectedExam(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Exam</option>
                                    <option value={"all"}>All Exam</option>
                                    {exams.map((exm) => {
                                        return (<>
                                            <option value={exm.id}>{exm.exam_name}</option>
                                        </>)
                                    })}
                                </select>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Test</label>
                                <select
                                    value={selectedTest}
                                    onChange={(e) => setSelectedTest(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Test</option>
                                    <option value={"all"}>All Test</option>
                                    {tests.map((tst) => {
                                        return (<>
                                            <option value={tst.id}>{tst.test?.test_name + " (" + tst.start_time + ")"}</option>
                                        </>)
                                    })}
                                </select>
                            </div>

                            <div className="flex justify-end space-x-2">
                                <button
                                    type="button"
                                    onClick={toggleExport}
                                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {isStatus && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-40">
                    <div className="bg-white p-6 rounded-md shadow-md w-full max-w-md">
                        <h2 className="text-lg font-semibold mb-4">Change Students Status</h2>
                        <form onSubmit={activateStudents}>
                            {/* Select User */}
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Organization</label>
                                <select
                                    value={selectedUser}
                                    onChange={(e) => setSelectedUser(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Organization</option>
                                    {(userType === 'super_admin') ? <>
                                        <option value={"all"}>All Organization</option>
                                    </> : ""}
                                    {organizations.map((org) => {
                                        return (<>
                                            <option value={org.id}>{org.name}</option>
                                        </>)
                                    })}
                                </select>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Exam</label>
                                <select
                                    value={selectedExam}
                                    onChange={(e) => setSelectedExam(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Exam</option>
                                    <option value={"all"}>All Exam</option>
                                    {exams.map((exm) => {
                                        return (<>
                                            <option value={exm.id}>{exm.exam_name}</option>
                                        </>)
                                    })}
                                </select>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Test</label>
                                <select
                                    value={selectedTest}
                                    onChange={(e) => setSelectedTest(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Test</option>
                                    <option value={"all"}>All Test</option>
                                    {tests.map((tst) => {
                                        return (<>
                                            <option value={tst.id}>{tst.test?.test_name + " (" + tst.start_time + ")"}</option>
                                        </>)
                                    })}
                                </select>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 mb-2">Select Status</label>
                                <select
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                                >
                                    <option value={""}>Select Status</option>
                                    <option value="true">Activate</option>
                                    <option value="false">De-Activate</option>
                                </select>
                            </div>

                            <div className="flex justify-end space-x-2">
                                <button
                                    type="button"
                                    onClick={toggleStatus}
                                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"students"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                                <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={() => goBack()}></i>Students</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                {(userType !== 'admin') ? <>
                                    <Link to={`/users`}><span class={`md:ml-5 ml-2 ${activeTab === 'Organization' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                        Organizations
                                    </span></Link>
                                    <Link to={`/students`}><span class={`md:ml-5 ml-2 ${activeTab === 'Student' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                        Students
                                    </span></Link></> : <></>}
                            </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-cyan-900 to-cyan-900 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            {/* <h3 class="mb-3 font-semibold">Students</h3> */}
                            <div className="flex flex-row items-center justify-between mb-3">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    onChange={handleFilterChange}
                                    className="p-1.5 shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]"
                                />
                                <div>
                                    <Link to={`/add_student`}><button className="p-1 text-sm font-bold text-teal-800 rounded-lg border-2 border-teal-800 hover:bg-teal-800 hover:text-white hover:border-transparent">
                                        + Add
                                    </button></Link>
                                    <button onClick={togglePopup} className="p-1 ms-3 text-sm font-bold text-green-700 rounded-lg border-2 border-green-700 hover:bg-green-700 hover:text-white hover:border-transparent">
                                        Import
                                    </button>
                                    <button onClick={() => toggleExport()} className="p-1 ms-3 text-sm font-bold text-orange-500 rounded-lg border-2 border-orange-500 hover:bg-orange-500 hover:text-white hover:border-transparent">
                                        Export
                                    </button>
                                    <button onClick={() => toggleStatus()} className="p-1 ms-3 text-sm font-bold text-blue-700 rounded-lg border-2 border-blue-700 hover:bg-blue-700 hover:text-white hover:border-transparent">
                                        Status
                                    </button>
                                </div>
                            </div>
                            <div className="max-h-[70vh] overflow-auto shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]">

                                {/* Data Table */}
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    highlightOnHover
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};